import { render, staticRenderFns } from "./AsyncWrapper.vue?vue&type=template&id=4eb4e6fe&scoped=true&"
import script from "./AsyncWrapper.vue?vue&type=script&lang=js&"
export * from "./AsyncWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AsyncWrapper.vue?vue&type=style&index=0&id=4eb4e6fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb4e6fe",
  null
  
)

export default component.exports